require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/pages/returns.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/pages/returns.legacy.js
// module id = 672
// module chunks = 31